<!-- delete complete booking modal -->
<section class="modal modal--{{modalData.type}}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="close($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modalData.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">Looks like the origin and/or destination is different than your original search. Do you want to continue with this flight or go back and
            search again?</p>
          <!-- <p>This is an {{ flightData.flightDirection === 1 ? 'outbound' : 'inbound' }} flight.</p> -->

          <!-- <div class="panel-body">
            <div class="flight-visual clearfix">
              <h2 class="pull-left" *ngIf="flightData.flightDirection === 1">
                <span class="flight-visual__city">
                  <span>{{ flightData.flightStatusDetails[flightData.primaryLeg - 1].departureAirport.airportCityName }}</span>
                </span>
                <span>{{ flightData.flightStatusDetails[flightData.primaryLeg - 1].departureAirport.airportCode }}</span>
              </h2>
              <i class="icon">plane_solid</i>
              <h2 class="pull-right" *ngIf="flightData.flightDirection === 2">
                <span class="flight-visual__city">
                  <span>{{ flightData.flightStatusDetails[flightData.primaryLeg - 1].arrivalAirport.airportCityName }}</span>
                </span>
                <span>{{ flightData.flightStatusDetails[flightData.primaryLeg - 1].arrivalAirport.airportCode }}</span>
              </h2>
            </div>
          </div> -->

        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-danger btn-ghost btn-block" (click)="goToFlightSearch($event)">
                Go back
              </button>
            </div>
            <div class="col-sm-6">
              <button style="background-color: #7850FA;" type="button" class="btn btn-primary btn-ghost btn-block" (click)="continue($event)">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>